import { ActionTypeList } from '../constants'

const initialState = {
    loading: false,
    wikiData: null,
    error: "",
};

const wikiDataPayload = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.WIKI_DATA_FETCHED:
            return {
                loading: false,
                wikiData: action.payload,
                error: ""
            };
        case ActionTypeList.WIKI_DATA_FETCH:
            return {
                loading: true,
                wikiData: null,
                error: action.payload
            };
        default:
            return state;
    }
}

export default wikiDataPayload;